export default __webpack_public_path__ + "static/hp-brand-deck-05-4fd3c8800d71934cb99b4ed6b6f1b2fa.png";